module.exports = __webpack_public_path__ + "static/img/pin-trap-mandatory.3eed1ce.svg";